<template>
	<div class="m-1">
		<b-modal ref="publish-modal" size="mg" id="modal-center" centered hide-footer title="银行卡" >
			<div>
			
				<div v-for="(item,index) in cardList" :key="item.id" id="item">
				
					<div v-if="payType=='yc'">
						<div class="p-3 border rounded mt-1 " role="button" @click="setCard(index)">
							<div><b>{{item.bankName}}</b>
									<b class="ml-5" v-if="item.cardType=='DEBIT'">借记卡</b>
									<b class="ml-5" v-else>贷记卡</b>
							</div>
							<div class="text-center"><b>{{item.bankCardNo}}</b></div>
						</div>	
					</div>
					<div v-else>
						<div class="p-3 border rounded mt-1 " role="button" @click="setCard(index)">
							<!-- <div><b>{{item.bankName}}</b>
									<b class="ml-5" v-if="item.cardType=='DEBIT'">借记卡</b>
									<b class="ml-5" v-else>贷记卡</b>
							</div> -->
							<div class="text-center"><b>{{item.bankCardNo}}</b></div>
							<div class="text-right">
							<a href="#" style="text-decoration: underline;text-align: center;"  @click="unbindCard(item.linkId)">解绑银行卡</a>
							</div>
						</div>	
					</div>	
				</div>
			
			</div>
		</b-modal>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				cardList:[],
				callback:null,
				payType:"yc",
			}
		},

		methods: {
		
			showModal(list,_call,_type) {
				this.cardList=list;
				this.callback=_call;
				this.payType=_type;
				this.$refs['publish-modal'].show()
			},
			
			setCard(_index){
				this.callback(_index)
				this.hideModal()
			},
			
			hideModal() {
				this.$refs['publish-modal'].hide()
			},
			
			_unBind(_linkid) {
				let that = this;
				let _openid = localStorage.getItem("_openid")
				this.$axios.get(that.$DOMAIN() + "/wechatApi/payease/unBindCard/" + _linkid, {
						headers: {
							"openid": _openid,
						}
					})
					.then(function(response) {
						if(response.data.data.result=="SUCCESS"){
							that.toast("解绑银行卡成功")
							that.hideModal()
							that.setCard(0)
						}else{
							that.toast("解绑银行卡失败")
						}
					})
					.catch(function(error) {
						console.log(error)
				});
			},
			
			
			unbindCard(_linkId){
				let that=this;
				const h = this.$createElement
				const messageVNode = h('div', {
					class: ['foobar']
				}, [
					h('p', {
						class: ['text-center']
					}, [
						"确认解绑此银行卡吗？"
					]),
				])
				this.$bvModal.msgBoxConfirm(messageVNode, {
						title: '解绑确认',
						size: 'md',
						buttonSize: 'md',
						okVariant: 'success',
						okTitle: '确认',
						cancelTitle: '取消',
						footerClass: 'p-2',
						hideHeaderClose: false,
						centered: true
					})
					.then(value => {
						if (value) {
							console.log("hello")
							that._unBind(_linkId)
						}
					})
					.catch(err => {
						console.log(err)
					})
			},
		
			toast(toaster, append = false) {
				this.counter++
				this.$bvToast.toast(toaster, {
					title: `提示`,
					toaster: "b-toaster-top-center",
					solid: true,
					variant: "danger",
					appendToast: append
				})
			},

			
		}
	}
</script>

<style>
	#item:hover {
		background-color:gainsboro;
		border-radius: 5px;
	}
	
</style>
